import React, { useState, useEffect, useContext } from "react";
// import { allSteps } from "./saveInvoiceData";
import axios from "axios";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import classes from "./ObjectPlaygroundComponents.module.scss";
import Button from "../UI/Button";
import StepsModal from "./StepsModal";
import { OrgIdContext } from "../../store/orgId_context";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.hostname + "/json.rpc";

const Steps = ({ onPassSteps }) => {
  const [adequateSteps, setAdequateSteps] = useState([]);
  const [checkedSteps, setCheckedSteps] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { mainOrgCountry } = useContext(OrgIdContext);

  const onStepsClickHandler = (e) => {
    const checkedValue = parseInt(e.target.value);
    let newCheckedSteps = [...checkedSteps];

    if (e.target.checked) {
      newCheckedSteps.push(checkedValue);
    } else {
      newCheckedSteps = newCheckedSteps.filter(
        (value) => value !== checkedValue
      );
    }
    newCheckedSteps.sort((a, b) => a - b);
    setCheckedSteps(newCheckedSteps);
    onPassSteps(newCheckedSteps);
  };

  const onOpenModalHandler = () => setIsModalOpen(true);

  const onCloseModalHandler = () => setIsModalOpen(false);

  function compareSteps(a, b) {
    return a.Step - b.Step;
  }

  useEffect(() => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Data.GetEntityData",
          params: {
            entity: "EU_WorkflowSteps",
          },
          id: 20211,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        axios
          .post(
            apiRequestAddress,
            {
              jsonrpc: "2.0",
              method: "Data.GetEntityData",
              params: {
                entity: "EU_SCR",
                filter: `CountryCode='${mainOrgCountry}'`,
              },
              id: 20212,
            },
            {
              withCredentials: true,
            }
          )
          .then((secRes) => {
            const defaultSteps =
              secRes.data.result.data[0].DefaultSteps.split(","); // array of default steps for the country

            const newSteps = res.data.result.data.filter((step) =>
              defaultSteps.includes(step.Step)
            );

            newSteps.push({
              Step: "999",
              StepDescription: "All steps set as default for specific country",
            });

            newSteps.sort(compareSteps);

            setAdequateSteps(newSteps);
          });
      });
  }, [mainOrgCountry]);

  return (
    <>
      <div className="d-flex gap-3">
        <span className={classes["span-label"]}>Add steps:</span>
        <Button
          className={`px-2 ${classes["second-btn"]}`}
          onClick={onOpenModalHandler}
        >
          Details
        </Button>
      </div>

      <div className={`${classes["input-field"]} my-3`}>
        {adequateSteps &&
          adequateSteps.map((step, index) => {
            const tooltip = (
              <Tooltip id={`tooltip-${index}`}>{step.StepDescription}</Tooltip>
            );

            return (
              <OverlayTrigger
                placement="bottom"
                overlay={tooltip}
                key={`overlay-trigger-${index}`}
                flip={false}
              >
                <div className={classes["steps-container"]}>
                  <input
                    key={`input-field-${index}`}
                    type="checkbox"
                    id={`input-field-${index}`}
                    className={classes["input-field__input"]}
                    value={step.Step.toString()}
                    onChange={onStepsClickHandler}
                  />
                  <label
                    htmlFor={`input-field-${index}`}
                    className={classes["input-field__label"]}
                  >
                    {step.Step}
                  </label>
                </div>
              </OverlayTrigger>
            );
          })}
      </div>

      <StepsModal
        isModalOpen={isModalOpen}
        onCloseModalHandler={onCloseModalHandler}
        stepsList={adequateSteps}
      />
    </>
  );
};

export default Steps;
